// Enum для типов услуг
export const ServiceType = {
  ELECTRICITY: 0,
  WATER: 1,
  GAS: 2,
  GAS_DELIVERY: 3,
  OTHER: 5
};

// Названия типов услуг
export const ServiceTypeNames = {
  [ServiceType.ELECTRICITY]: 'Электричество',
  [ServiceType.WATER]: 'Вода',
  [ServiceType.GAS]: 'Газ',
  [ServiceType.GAS_DELIVERY]: 'Доставка газа',
  [ServiceType.OTHER]: 'Другое'
};

// Массив для select options
export const ServiceTypeOptions = [
  { value: ServiceType.ELECTRICITY, label: ServiceTypeNames[ServiceType.ELECTRICITY] },
  { value: ServiceType.WATER, label: ServiceTypeNames[ServiceType.WATER] },
  { value: ServiceType.GAS, label: ServiceTypeNames[ServiceType.GAS] },
  { value: ServiceType.GAS_DELIVERY, label: ServiceTypeNames[ServiceType.GAS_DELIVERY] },
  { value: ServiceType.OTHER, label: ServiceTypeNames[ServiceType.OTHER] }
];

// Функция для получения названия по значению
export const getServiceTypeName = (typeValue) => {
  return ServiceTypeNames[typeValue] || ServiceTypeNames[ServiceType.OTHER];
};
